module.exports = __webpack_public_path__ + "static/img/autCt_bg_01.adf82c1b.svg";